/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  SelectComponentsConfig,
} from 'react-select';

import { ClearIndicator } from '../components/ClearIndicator';
import { IndicatorSeparator } from '../components/IndicatorSeparator';
import { MenuList, WrappedMenuList } from '../components/MenuList';
import { MultiValueRemove } from '../components/MultiValueRemove';

import { Control } from './Control';
import { DropdownIndicator } from './DropdownIndicator';
import { Option } from './Option';

const createComponents = (isAsync: boolean): SelectComponentsConfig<any, any, any> => ({
  ClearIndicator,
  Control,
  DropdownIndicator,
  IndicatorSeparator,
  MenuList: isAsync ? WrappedMenuList : MenuList,
  MultiValueRemove,
  Option,
});

export const selectComponentsSync = createComponents(false);
export const selectComponentsAsync = createComponents(true);
